import { FeedTypeEnum, IFeedModules } from "@/common/services/types";

interface IProps {
  feedModules?: IFeedModules;
  feed: FeedTypeEnum;
  position: number;
}

export const findFeedModules = ({ feedModules, feed, position }: IProps) => {
  if (!feedModules || !feedModules[feed]) {
    return null;
  }

  return feedModules[feed].filter(module => {
    if (module.position === 0 && module.position_factor === 0) {
      return false;
    }

    if (module.position_factor === 0 && module.position === position + 1) {
      return true;
    }

    return module.position_factor !== 0 && ((position + 1) % module.position_factor) === 0;
  });
};
